module.exports = __webpack_public_path__ + "img/dksuccess1.8c4c91dd.png";